import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { GET_VBC_USER_SUBSCRIPTION } from '../gql/queries';
import { useQuery } from '@apollo/client';
import { getIdTokenCookie } from '@chegg/utils';
import configureApolloForCommerce from '../gql/configureApolloForCommerce';
import { isProd } from '../common/helper';
import { APOLLO_COMMERCE_CONTEXT } from '../gql/constants';

/**
 * Call myLatestSubscriptionV1 call
 * @param options
 * @param teamName
 * @returns MyLatestSubscriptionsV1WithDates
 */
var useMyLatestSubscriptionV1 = function useMyLatestSubscriptionV1(options, __, environment) {
  var skip = !getIdTokenCookie() || (options === null || options === void 0 ? void 0 : options.skip);
  if (environment) {
    configureApolloForCommerce(isProd(environment), window.location.hostname);
  }
  var _useQuery = useQuery(GET_VBC_USER_SUBSCRIPTION, _objectSpread({
      skip: skip,
      fetchPolicy: 'cache-first'
    }, environment && {
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    })),
    orderHistoryLoading = _useQuery.loading,
    orderError = _useQuery.error,
    data = _useQuery.data,
    myLatestSubscriptionsRefetch = _useQuery.refetch;
  if (skip) {
    return {
      status: 'skipped'
    };
  }
  if (orderHistoryLoading) {
    return {
      status: 'loading'
    };
  }
  var refetch = function refetch() {
    myLatestSubscriptionsRefetch();
  };
  if (!data || orderError) {
    return {
      refetch: refetch,
      status: 'error',
      metadata: orderError
    };
  }
  return {
    data: data,
    refetch: refetch,
    status: 'ok'
  };
};
export default useMyLatestSubscriptionV1;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useMyLatestSubscriptionV1.js
// module id = 4164
// module chunks = 11